(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-cart-summary"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const validHouses = ["Mom's House", "Dad's House"];
    const selectSelector = '.mssd-cart-summary select[name="attributes[Order House]"]';

    const currentSelect = () => document.querySelector(selectSelector);
    const currentSummary = () => document.querySelector('.mssd-cart-summary');
    const checkoutButtons = () => Array.from(document.querySelectorAll('button[name="checkout"], input[name="checkout"]'))
      .filter((button) => button.form && button.form.id === 'cart');

    const setCheckoutState = (enabled) => {
      checkoutButtons().forEach((button) => {
        button.disabled = !enabled;
        button.setAttribute('aria-disabled', String(!enabled));
      });
    };

    const updateDisplay = (house, state, message, collapse) => {
      const summary = currentSummary();
      if (!summary) return;

      const details = summary.querySelector('[data-mssd-house-details]');
      const label = summary.querySelector('[data-mssd-house-summary-label]');
      const value = summary.querySelector('[data-mssd-house-summary-value]');
      const change = summary.querySelector('.mssd-cart-summary__change');
      const status = summary.querySelector('[data-mssd-house-status]');
      const valid = validHouses.includes(house);

      if (label) label.textContent = valid ? 'Delivery group' : 'Choose a delivery group';
      if (value) value.textContent = valid ? house : 'Required';
      if (change) change.textContent = valid ? 'Change' : 'Choose';
      if (status) {
        status.dataset.state = state;
        status.textContent = message;
      }
      if (collapse && details && valid) details.open = false;
    };

    const saveHouse = async (house) => {
      const valid = validHouses.includes(house);
      setCheckoutState(false);

      if (!valid) {
        updateDisplay('', 'required', 'Choose a delivery group to continue.', false);
        return;
      }

      updateDisplay(house, 'saving', 'Saving delivery group…', false);
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

      try {
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Order House': house } })
        });
        if (!response.ok) throw new Error('Unable to save delivery group');
        await response.json();
        updateDisplay(house, 'ready', 'Delivery group saved.', true);
        setCheckoutState(true);
      } catch (error) {
        updateDisplay(house, 'error', 'Ready for checkout. This choice will be saved with your order.', false);
        setCheckoutState(true);
      }
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches(selectSelector)) return;
      saveHouse(event.target.value);
    });

    document.addEventListener('mssd:house-saved', (event) => {
      const select = currentSelect();
      const house = event.detail ? event.detail.house : null;
      if (!select || !validHouses.includes(house)) return;
      select.value = house;
      updateDisplay(house, 'ready', 'Delivery group saved from your link.', true);
      setCheckoutState(true);
    });

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      const select = currentSelect();
      if (select && validHouses.includes(select.value)) return;

      event.preventDefault();
      if (select) {
        const details = select.closest('[data-mssd-house-details]');
        if (details) details.open = true;
        updateDisplay('', 'required', 'Choose a delivery group to continue.', false);
        select.scrollIntoView({ behavior: 'smooth', block: 'center' });
        select.focus();
      }
    }, true);

    const start = async () => {
      const select = currentSelect();
      if (!select) return;
      setCheckoutState(false);

      let house = select.value;

      // Cart attributes can be written by a house-specific share link just
      // before the customer opens the cart. Read the cart once on load so the
      // checkout state always reflects the saved value, even when Shopify's
      // initial Liquid response was rendered before that write completed.
      if (!validHouses.includes(house)) {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        try {
          const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          if (response.ok) {
            const cart = await response.json();
            house = cart.attributes && cart.attributes['Order House'];
          }
        } catch (error) {
          house = '';
        }
      }

      const valid = validHouses.includes(house);
      if (valid) {
        select.value = house;
        updateDisplay(house, 'ready', 'Delivery group saved.', true);
      } else {
        updateDisplay('', 'required', 'Choose a delivery group to continue.', false);
      }
      setCheckoutState(valid);
    };

    // Dawn replaces the cart summary markup after a quantity change. Watch
    // only for a new select element (not every text mutation) so the saved
    // house is restored without creating an observer/update loop.
    let observedSelect = currentSelect();
    const cartObserver = new MutationObserver(() => {
      const select = currentSelect();
      if (!select || select === observedSelect) return;
      observedSelect = select;
      start();
    });
    cartObserver.observe(document.documentElement, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-checkout-guard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const guard = document.querySelector('.mssd-checkout-guard');
    const salePath = guard?.dataset.salePath || '/collections/mums-for-mia';
    const continueLabel = guard?.dataset.continueLabel || 'Continue shopping';
    const saleClosed = guard?.dataset.saleClosed === 'true';
    const updateCartLinks = () => {
      document.querySelectorAll('.cart__warnings a.button, .title-wrapper-with-link a.underlined-link').forEach((link) => {
        link.href = salePath;
        link.textContent = continueLabel;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCartLinks, { once: true });
    } else {
      updateCartLinks();
    }

    if (saleClosed) {
      document.querySelectorAll('form[action*="/cart/add"], form[action="/cart"]').forEach((form) => {
        form.addEventListener('submit', (event) => event.preventDefault(), true);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-house-bridge"]) return;
  try {
    
  (() => {
    const key = new URLSearchParams(window.location.search).get('house');
    const house = key === 'mom' ? "Mom's House" : key === 'dad' ? "Dad's House" : null;
    if (!house) return;

    const notice = document.querySelector('[data-mssd-house-bridge]');
    const message = notice && notice.querySelector('[data-mssd-house-bridge-message]');
    const change = notice && notice.querySelector('[data-mssd-house-bridge-change]');
    let hideTimer;

    const showNotice = (copy, state, showChange = false) => {
      if (!notice || !message) return;
      window.clearTimeout(hideTimer);
      message.textContent = copy;
      notice.dataset.state = state;
      notice.hidden = false;
      if (change) change.hidden = !showChange;
      if (state === 'saved') {
        hideTimer = window.setTimeout(() => {
          notice.hidden = true;
        }, 8000);
      }
    };

    showNotice('Saving delivery group…', 'saving');

    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Order House': house } })
    }).then((response) => {
      if (!response.ok) throw new Error('House assignment failed');
      return response.json();
    }).then(() => {
      document.documentElement.dataset.mssdOrderHouse = house;
      document.dispatchEvent(new CustomEvent('mssd:house-saved', { detail: { house } }));
      showNotice(`Delivery group: ${house}`, 'saved', true);
    }).catch(() => {
      document.documentElement.dataset.mssdOrderHouseError = 'true';
      showNotice('Delivery group could not be saved. Choose it in the cart.', 'error', true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-order-house"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHouseSelectors = () => {
      const validHouses = ["Mom's House", "Dad's House"];

      document.querySelectorAll('[data-mssd-cart-house]').forEach((section) => {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        const select = section.querySelector('select[name="attributes[Order House]"]');
        const status = section.querySelector('[data-mssd-house-status]');
        if (!select) return;

        const checkoutButtons = () => Array.from(document.querySelectorAll('button[name="checkout"], input[name="checkout"]'))
          .filter((button) => button.form && button.form.id === 'cart');
        const hasValidHouse = () => validHouses.includes(select.value);
        const setCheckoutState = () => {
          const valid = hasValidHouse();
          checkoutButtons().forEach((button) => {
            button.disabled = !valid;
            button.setAttribute('aria-disabled', String(!valid));
          });
          if (!valid && status) {
            status.dataset.state = 'error';
            status.textContent = 'Select a house to continue to checkout.';
          }
          return valid;
        };

        select.addEventListener('change', () => {
          const valid = setCheckoutState();
          if (valid && status) {
            status.dataset.state = 'saved';
            status.textContent = 'Ready for checkout.';
          }
        });

        document.addEventListener('submit', (event) => {
          const submitter = event.submitter;
          if (submitter && submitter.name === 'checkout' && !setCheckoutState()) {
            event.preventDefault();
            section.scrollIntoView({ behavior: 'smooth', block: 'center' });
            select.focus();
          }
        }, true);

        setCheckoutState();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeHouseSelectors);
    } else {
      initializeHouseSelectors();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mssd-product-dock"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const docks = Array.from(document.querySelectorAll('[data-mssd-product-dock]'));
    if (!docks.length) return;

    const getMainForm = () => Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find((form) => !form.closest('[data-mssd-product-dock]'));
    let syncTimer;

    const syncDock = (variantId, syncQuantity = true) => {
      const mainForm = getMainForm();
      if (!mainForm) return;
      const mainVariant = mainForm.querySelector('input[name="id"]');
      const mainQuantity = document.querySelector('.product__info-container input[name="quantity"]');
      const mainButton = mainForm.querySelector('[name="add"]');
      const currentVariantId = String(variantId || mainVariant?.value || '');

      docks.forEach((dock) => {
        const dockVariant = dock.querySelector('[data-mssd-dock-variant]');
        const dockQuantity = dock.querySelector('[data-mssd-dock-quantity]');
        const dockOption = dock.querySelector('[data-mssd-dock-option]');
        const dockPrice = dock.querySelector('[data-mssd-dock-price]');
        const dockButton = dock.querySelector('[data-mssd-dock-button]');
        const variantData = Array.from(dock.querySelectorAll('[data-variant-id]')).find((item) => item.dataset.variantId === currentVariantId);

        if (currentVariantId && dockVariant) dockVariant.value = currentVariantId;
        if (syncQuantity && mainQuantity && dockQuantity && document.activeElement !== dockQuantity) {
          dockQuantity.value = Math.max(1, Number.parseInt(mainQuantity.value, 10) || 1);
        }
        if (variantData && dockOption) dockOption.textContent = variantData.dataset.variantOption;
        if (variantData && dockPrice) dockPrice.textContent = variantData.dataset.variantPrice;

        if (dockButton) {
          const isAvailable = variantData ? variantData.dataset.variantAvailable === 'true' : !mainButton?.disabled;
          dockButton.disabled = !isAvailable;
          dockButton.textContent = isAvailable ? 'Add to cart' : 'Unavailable';
        }
      });
    };

    const queueSync = (variantId) => {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(() => syncDock(variantId), 100);
    };

    document.addEventListener('change', (event) => {
      const dock = event.target.closest('[data-mssd-product-dock]');
      if (dock) {
        if (event.target.matches('[data-mssd-dock-quantity]')) {
          event.target.value = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
        }
        return;
      }

      if (event.target.matches('form[action*="/cart/add"] input[name="id"]')) {
        syncDock(event.target.value);
        return;
      }

      const isOption = event.target.closest('variant-selects, variant-radios, .product-form__input');
      const isQuantity = event.target.matches('input[name="quantity"]');
      if (!isOption && !isQuantity) return;
      queueSync();
    });

    document.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-mssd-dock-quantity-change]');
      if (!quantityButton) return;
      const dock = quantityButton.closest('[data-mssd-product-dock]');
      const quantityInput = dock?.querySelector('[data-mssd-dock-quantity]');
      if (!quantityInput) return;
      const change = Number.parseInt(quantityButton.dataset.mssdDockQuantityChange, 10) || 0;
      quantityInput.value = Math.max(1, (Number.parseInt(quantityInput.value, 10) || 1) + change);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    docks.forEach((dock) => {
      dock.querySelector('form')?.addEventListener('submit', () => syncDock(null, false));
    });

    const productInfo = document.querySelector('.product__info-container');
    if (productInfo) {
      new MutationObserver(() => queueSync()).observe(productInfo, { childList: true, subtree: true });
    }

    syncDock();
  })();

  } catch(e) { console.error(e); }
})();
})();
